export default __webpack_public_path__ + "static/lunaria_background-cd3f887311c539fed28122f4d7378f99.svg";